import {ApiHelper, axiosInstance } from '../../utils/ApiHelper'
import { toRangeParams } from './reducer'
import moment from 'moment'

export function onRangeChange(values) {
  return (dispatch) => {
    dispatch({type:'UPDATE_RANGE', range: values})

    dispatch(getUpdatedTotals())
  }
}


export function getUpdatedTotals() {
  return (dispatch, getState) => {
    dispatch({type:"REQUEST_UPDATE_TAX_CENTER"})

    const { range } = getState().account.taxCenter

    // reject if empty array
    if (!range.length) return dispatch({type:"REJECT_UPDATE_TAX_CENTER", range})

    const url = `users/me/totals`
    return axiosInstance.get(url, {params: toRangeParams(range)} )
    .then((response)=>{
      dispatch({type:'UPDATE_TAX_CENTER', totals: response.data})

    })

  }
}



// WEBPACK FOOTER //
// ./src/account/tax-center/actions.js